import React from 'react';
import {
  ArrowUpward,
  PersonAddOutlined,
  OpenInBrowser,
  AssignmentIndOutlined,
  HouseOutlined,
  AssessmentOutlined,
  RateReviewOutlined,
  Close,
  MoneyOff,
  DirectionsWalk,
  Assignment,
  Cancel,
} from '@material-ui/icons';

import {
  FamilyRestroom,
  Psychology,
  Reviews,
  SocialDistance,
  Event,
  ArrowForward,
  Restaurant,
  Group,
  ChildCare as Baby,
  EscalatorWarning,
  UploadFile,
  IntegrationInstructions,
} from '@mui/icons-material';

export interface IProgressTypesIcons {
  [key: string]: any;
}

export const progressTypeIcons: IProgressTypesIcons = {
  adoption: <FamilyRestroom />,
  declaration: <IntegrationInstructions />,
  update: <UploadFile />,
  foodForward: <Restaurant />,
  groupForward: <Group />,
  clinicForward: <DirectionsWalk />,
  consultantRequest: <Restaurant />,
  evolution: <ArrowUpward />,
  monthlyEvolution: <ArrowUpward />,
  register: <PersonAddOutlined />,
  init: <OpenInBrowser />,
  parentInit: <EscalatorWarning />,
  screening: <AssignmentIndOutlined />,
  babyScreening: <Baby />,
  hosting: <HouseOutlined />,
  assessment: <AssessmentOutlined />,
  review: <RateReviewOutlined />,
  forwarding: <ArrowForward />,
  socialService: <SocialDistance />,
  parents: <FamilyRestroom />,
  psychopedagogy: <Psychology />,
  closure: <Close />,
  discount: <MoneyOff />,
  diagnosis: <Reviews />,
  psychiatric: <Assignment />,
  quarterplan: <Event />,
  monthlyNutritionEvolution: <Restaurant />,
  psychiatryEvolution: <Assignment />,
  inactivateRecord: <Cancel />,
};
